<template>
  <div>
    <div id="lContent">
      <div id="conList">
        <div id="wTable">
          <div id="tab1">讲解队伍建设</div>
          <div id="tab2">时间</div>
        </div>
        <router-link id="oneCon" v-for="(item, index) in tableData"
          :key="index" tag="div" :to="{path:'/Social/explainDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">
          <div id="navdht"><img src="../../assets/img/navdh.png"></div>
          <div>
            <div class="text">{{ item.title }}</div>
            <div><span>{{ item.time }}</span></div>
          </div>
        </router-link>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin: 3.125rem;text-align:right">
      </el-pagination>
    </div>
    <div id="mlContent">
      <div id="mconList">
        <div id="mwTable">
          <div id="mtab1">讲解队伍建设</div>
          <div id="mtab2">时间</div>
        </div>
        <router-link id="moneCon" v-for="(item, index) in marrData"
          :key="index" tag="div" :to="{path:'/Social/explainDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">
          <div id="mnavdht"><img src="../../assets/img/mnavdh.png"></div>
          <div>
            <div class="text">{{ item.titlestr }}</div>
            <div><span>{{ item.time }}</span></div>
          </div>
        </router-link>
      </div>
      <el-pagination @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, prev, pager, next" :total="pageTotal.total" style="margin: 1.875rem;text-align:right">
      </el-pagination>
    </div>
  </div>

</template>

<script>
  import moment from 'moment'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
        mtableData: [],
        marrData: []
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("lContent").style.display = "none";
        this.mhandleSearch()
      } else {
        document.getElementById("mlContent").style.display = "none";
        document.getElementById("lContent").style.display = "block";
        this.handleSearch()
      }

    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.tableData = [];
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.marrData = [];
        this.msearch();
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("conList").style.width = eWidth * 0.9 + "px";
        document.getElementById("wTable").style.width = eWidth * 0.9 + "px";
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        this.loading = true;
        let url = this.HOST + '/api/v1/social/explainAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableData = [];
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
        }).catch(function(error) {
          console.log(error);
        })
      },
      mhandleSearch() {
        this.msearch();
      },
      // 查询列表
      msearch: function() {
        let that = this;
        this.loading = true;
        let url = this.HOST + '/api/v1/social/explainAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.marrData = [];
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.mtableData = cData.data.list;
          for (let k = 0; k < that.mtableData.length; k++) {
            let str = {};
            str.id = that.mtableData[k].id;
            str.time = that.mtableData[k].time;
            if (that.mtableData[k].title.length > 10) {
              str.titlestr = (that.mtableData[k].title).substring(0, 10) + "...";
            } else {
              str.titlestr = that.mtableData[k].title;
            };
            that.marrData.push(str);
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
    }
  }
</script>

<style scoped>
  #lContent {
    display: none;
  }

  #wTable {
    height: 60px;
    position: relative;
    background: #DEDEDE;
    margin-top: 25px;
  }

  #tab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    left: 50px;
    font-weight: 500;
  }

  #tab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1.3em;
    top: 15px;
    right: 0;
    font-weight: 500;
    margin-right: 95px;
  }

  #navdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 20px;
    left: 4.4%;
    cursor: pointer;
  }

  #navdht>img {
    width: 100%;
    height: 100%;
  }

  #oneCon {
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
  }

  #oneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 7%;
  }

  #oneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 0%;
    margin-right: 50px;
    cursor: pointer;
  }

  #oneCon>div>.text {
    cursor: pointer;
  }

  #oneCon>div>.text:hover,
  #oneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }

  /*mobile*/
  #mconList {
    margin: auto 10px;
  }

  #mwTable {
    height: 60px;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
  }

  #mtab1 {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    left: 10%;
    font-weight: 500;
  }

  #mtab2 {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 15px;
    right: 17%;
    font-weight: 500;
  }

  #mnavdht {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 30px;
    left: 20px;
    cursor: pointer;
  }

  #mnavdht>img {
    width: 100%;
    height: 100%;
  }

  #moneCon {
    height: 80px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
  }

  #moneCon>div>div:nth-child(1) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 25px;
    left: 50px;
  }

  #moneCon>div>div:nth-child(2) {
    position: absolute;
    line-height: 30px;
    font-size: 1em;
    top: 25px;
    right: 5%;
    cursor: pointer;
  }

  #moneCon>div>.text {
    cursor: pointer;
  }

  #moneCon>div>.text:hover,
  #moneCon>div>div:nth-child(2):hover {
    color: #FF2222;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Social/explain.vue